import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  copyQuestionAnswer: {
    zIndex: 100,
  },
}));

export default useStyles;
